import React , {useState , useEffect , Fragment} from "react";
import DataTable from 'react-data-table-component';
import { api_Routes } from "../../api_Route";
import { Helper } from "../../Tools/Helper";
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Typography , TextField } from "@mui/material";
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import {  Select, MenuItem } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Files from 'react-files';

const AddBreed = () => {
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate()
    const [isLoadingDetiales, setIsLoadingDetailes] = useState(false)
    const [page, setPage] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [langauges, setLangauges] = useState([])
    const [formData, setFormData]  = useState({
        name:"",
        origin:"",
        type:"",
        photo: [] 
    })
    const [dataToEditorState, setDataToEditorState] = useState({});


    useEffect(() => {
        
        if (localStorage.hasOwnProperty("lang")) {
            let array = JSON.parse(localStorage.getItem("lang"));
            setLangauges(array);
            
                setDataToEditorState(prev => {
                    array.forEach((e) => {
                        prev[e.id] = {
                            name: { id: 0, value: "" },
                            advantages: { id: 0, value: ""}, 
                            disadvantages: { id: 0, value: ""}, 
                            additional_notes: { id: 0, value: ""}, 
                        };
                    });
                    return prev;
                });
            
        }
    }, []);

    const handleChange = (key, value, id_lang, id, sort) => {
        console.log(value)
            if (id_lang) {
                let translations = { ...dataToEditorState };
                let valueTemp = ''
              
                    valueTemp  = value
                
                translations[id_lang][key] = { id:id, value:valueTemp};
                setDataToEditorState(translations);
            } else {
                setFormData(prev => ({ ...prev, [key]: value }));
            }
        };

     const handleSubmit = async () => {
            let exit = false

       const requiredFields = [
    "name",
    "origin",
    "type",
];

const missingFields = requiredFields.filter((field) => !formData[field]);

if (missingFields.length > 0 || !formData.photo) {
    let errorMessage = "";

    if (missingFields.length > 0) {
        errorMessage += `Please fill in all required fields: ${missingFields.join(", ")}. `;
    }

    if (!formData.photo) {
        errorMessage += `Please upload a photo.`;
    }

    enqueueSnackbar(errorMessage, {
        variant: "error",
        anchorOrigin: {
            vertical: "top",
            horizontal: "right",
        },
    });

    setIsLoading(false);
    return;
}

setIsLoading(true);


            var form_data = new FormData();
            var updatedFormData = { ...formData };
            var valueTemp = ''

            Object.keys(dataToEditorState).forEach((key,value) => {
                Object.keys(dataToEditorState[key]).forEach((subKey) => {
                   
                            if (dataToEditorState[key][subKey].value) {
                                valueTemp = dataToEditorState[key][subKey].value;
                            } else {
                                 exit = true
                            }
                        form_data.append(`languages[${key}][${subKey}]`, valueTemp);
                })
   
            })


            Object.keys(updatedFormData).forEach((key) => {
                if (key === "photo")
                    updatedFormData[key].forEach((file, index) => {
                        form_data.append(`photos[]`, file);
                    });
                else
                    form_data.append(key, updatedFormData[key]);
            });

                form_data.append("_method", "PUT");
            
            if(exit){
                enqueueSnackbar("Please add name , advantages , disadvantages , additional_notes ",{variant:"error",anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                  }})
                setIsLoading(false)
                return;
            }

            const { response, message } = await Helper.Post({
                url: api_Routes.breed.add ,
                data: form_data,
                hasToken: true
            });

            if (response) {
                enqueueSnackbar(message,{variant:"success",anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                  }})       
                  navigate(`/breed`)     
                    setIsLoading(false);
            } else {
                if (typeof message === "string") {
                    enqueueSnackbar(message,{variant:"error",anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                      }})
                } 
                setIsLoading(false);
            }
        };  

        const [files, setFiles] = useState([]);
        
        const onFilesChange = (uploadedFiles) => {
            const newFiles = uploadedFiles.map(file => ({
                url: URL.createObjectURL(file),
                file // Store the actual file object for uploading later
            }));
        
            setFiles(prevFiles => [...prevFiles, ...newFiles]);
        
            setFormData(prev => ({
                ...prev,
                photo: [...(prev.photo || []), ...newFiles.map(f => f.file)] // Ensure photo is an array
            }));
        };
        
        function deleteFile(indexToRemove) {
            const newFiles = files.filter((_, index) => index !== indexToRemove);
            setFiles(newFiles);
            setFormData(prev => ({
                ...prev,
                photo: newFiles.map(f => f.file) // Update formData with remaining files
            }));
        }
        const onFilesError = (error, file) => {
            setFormData(prev=>({...prev,["photo"]:""}))
            setFiles(file)
        }


        return(
            <>
                <Container sx={{ marginBottom: "20px" }}>
                <Grid container sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                    <Grid item>
                        <Typography sx={{ fontSize: "28px", fontWeight: "600", color: "#1e1b1b" }}>Add Breed</Typography>
                    </Grid>
                    <Grid item>
                    <Button 
                        variant="contained" 
                        startIcon={isLoading ? <CircularProgress color="success" size={22}/> : <AddIcon />} 
                        sx={{ 
                            backgroundColor: "#244729", 
                            fontSize: "13px", 
                            borderRadius: "7px", 
                            height: "38px",
                            '&:hover': {
                                backgroundColor: "#244710" // Green color on hover
                            }
                        }} 
                        onClick={handleSubmit}
                    >
                        Save
                    </Button>
                    </Grid>
                </Grid>
                <Card>
                    <CardContent sx={{paddingBottom:"40px !important"}}>
                        <h3 style={{fontWeight:500,marginBottom:"30px"}}>Basic information</h3>
                        <Box component="form" noValidate autoComplete="off">
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <InputLabel className="inputlable">Name</InputLabel>
                                    <TextField 
                                     sx={{width:{xs:"100%",sm:"auto"}}}
                                        label="name" 
                                        variant="outlined" 
                                         
                                        name="name" 
                                        value={formData.name} 
                                        onChange={(e)=>{handleChange("name",e.target.value)}} 
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                <InputLabel className="inputlable">Origin</InputLabel>

                                    <TextField 
                                     sx={{width:{xs:"100%",sm:"auto"}}}
                                        label="origin" 
                                        variant="outlined" 
                                         
                                        name="origin" 
                                        value={formData.origin} 
                                        onChange={(e)=>{handleChange("origin",e.target.value)}} 
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                <InputLabel className="inputlable">Type</InputLabel>

                                    <TextField 
                                     sx={{width:{xs:"100%",sm:"auto"}}}
                                        label="type" 
                                        variant="outlined" 
                                         
                                        name="type" 
                                        value={formData.type} 
                                        onChange={(e)=>{handleChange("type",e.target.value)}}  
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Container>
            {
            Object.keys(dataToEditorState).length > 0 && langauges.length > 0 && langauges.map((lang,i)=>(<Container sx={{ marginBottom: "20px" }}>
                <Card>
                    <CardContent>
                        <h3 style={{fontWeight:500,marginBottom:"30px"}}>{`${lang.name} information`}</h3>
                        <Box component="form" noValidate autoComplete="off">
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                <InputLabel className="inputlable">Name</InputLabel>

                                    <TextField 
                                        label="name" 
                                        variant="outlined" 
                                        fullWidth 
                                        name="name" 
                                        value={dataToEditorState[JSON.stringify(lang.id)]?.name.value} 
                                        onChange={(e)=>{handleChange("name",e.target.value,lang.id,null,0)}}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                <InputLabel className="inputlable">Advantages</InputLabel>

                                    <TextField 
                                        label="advantages" 
                                        variant="outlined" 
                                        fullWidth 
                                        name="origin" 
                                        value={dataToEditorState[JSON.stringify(lang.id)]?.advantages.value} 
                                        onChange={(e)=>{handleChange("advantages",e.target.value,lang.id,null,1)}} 
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                <InputLabel className="inputlable">Disadvantages</InputLabel>

                                    <TextField 
                                        label="disadvantages" 
                                        variant="outlined" 
                                        fullWidth 
                                        name="type" 
                                        value={dataToEditorState[JSON.stringify(lang.id)]?.disadvantages.value} 
                                        onChange={(e)=>{handleChange("disadvantages",e.target.value,lang.id,null,2)}}  
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                <InputLabel className="inputlable">Additional Notes</InputLabel>

                                    <TextField 
                                        label="additional notes" 
                                        variant="outlined" 
                                        fullWidth 
                                        name="type" 
                                        value={dataToEditorState[JSON.stringify(lang.id)]?.additional_notes.value} 
                                        onChange={(e)=>{handleChange("additional_notes",e.target.value,lang.id,null,3)}}  
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Container>))}
            <Container sx={{ marginBottom: "50px" }}>
                <Card>
                    <CardContent>
                        <h3>Upload Image</h3>
                        <Box component="form" noValidate autoComplete="off">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} textAlign={"center"}>
                                <Files
                                    className='files-dropzone fileContainer'
                                    onChange={onFilesChange}
                                    onError={onFilesError}
                                    accepts={['image/*']}
                                    multiple={true}
                                    maxFileSize={10000000}
                                    minFileSize={0}
                                    clickable
                                >
                                    <Grid container spacing={2}>
                                        {files.length > 0 && (
                                            <>
                                                {files.map((file, index) => (
                                                    <Grid item xs={12} sm={6} key={index}>
                                                        <img
                                                            width="100%" // Adjust width to fit within the grid item
                                                            height="200px"
                                                            alt="img"
                                                            src={file.url}  // Display using the URL
                                                            style={{ objectFit: "cover", borderRadius: "8px" }}
                                                        />
                                                    </Grid>
                                                ))}
                                            </>
                                        )}
                                    </Grid>
                                    <Button 
                                        sx={{
                                            marginTop: "20px",
                                            backgroundColor: "#244729",
                                            color: "white",
                                            padding: "10px",
                                            '&:hover': { backgroundColor: "#244710", color: "white" }
                                        }} 
                                    >
                                        Upload Image
                                    </Button>
                                </Files>
                                <div style={{ display: "flex", justifyContent: "center", marginTop: "30px", flexDirection: "row" }}>
                                    {files.length > 0 && files.map((file, index) => (
                                        <Button
                                            key={index}
                                            onClick={() => deleteFile(index)}
                                            sx={{
                                                backgroundColor: "red",
                                                marginLeft: "8px",
                                                color: "white",
                                                padding: "8px 16px",
                                                '&:hover': { backgroundColor: "darkred", color: "white" }
                                            }}
                                        >
                                            Delete {`${index + 1}`}
                                        </Button>
                                    ))}
                                </div>
                            </Grid>
                        </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Container>
            </>
        )


}
export default AddBreed